import type { EmailEditorPanelType } from "@lib/channelConstants";

export const mapEmailMissingActiveComponentNameToComposerPanel = (componentName: string): EmailEditorPanelType => {
  if (componentName && componentName.match(/sender|subject|preheader/i)) {
    return "SENDING_INFO";
  }
  // this is arbitrary, as we don't actually know where they want it, but let's default to body for now
  return "BODY";
};
